import ShowroomDownloadsAttach from "./showroom-downloads-attach";

export default ShowroomDownloadsAttach;